module.exports = __webpack_public_path__ + "static/media/Tabs.52653c63.less";


//////////////////
// WEBPACK FOOTER
// ./src/tabs/Tabs.less
// module id = 1007
// module chunks = 0